import { Phone, MessageCircle } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, waLink } from "@/lib/site";

export default function Header() {
  return (
    <header className="fixed top-0 inset-x-0 z-40 bg-black/85 backdrop-blur-xl border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 h-16 md:h-20 flex items-center justify-end gap-3">
        <div className="flex items-center gap-3 md:gap-5">
          <a
            href={PHONE_TEL}
            data-testid="header-phone-link"
            className="hidden md:flex items-center gap-2 text-white/90 hover:text-[#FEFB0E] transition-colors font-semibold"
          >
            <Phone className="w-4 h-4" />
            {PHONE_DISPLAY}
          </a>
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-whatsapp-btn"
            className="flex items-center gap-2 bg-[#50CF08] hover:bg-[#42B006] text-white font-bold uppercase text-sm md:text-base px-4 md:px-6 py-2.5 md:py-3 rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-[#FEFB0E]"
          >
            <MessageCircle className="w-5 h-5" />
            Chamar agora
          </a>
        </div>
      </div>
    </header>
  );
}
